import { Tooltip, styled } from "@mui/material";

const GradientTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, ownerState }) => {
  // console.log('ownerState',ownerState)
  const bg =
    ownerState.variant === "pipeline"
      ? 'linear-gradient(to left, rgb(20, 30, 48), rgb(36, 59, 85))'
      : "linear-gradient(to left, rgb(34, 34, 34), rgb(68, 66, 71))";

  const Color = ownerState.color === 'falla'
      ? '#8e712c'
      : '#c3c3c3'

  return {
    [`& .MuiTooltip-tooltip`]: {
      background: bg,
      color: Color,
      fontSize: "0.7vw",
      padding: "0.5vh 0.8vw",
      maxWidth: "20vw",
      whiteSpace: "pre-line",
      borderRadius: '0.4vw',
    },
    [`& .MuiTooltip-arrow`]: {
      color: bg,
    },
  };
});

export default function CustomTooltip({ variant = "pipeline", color = 'falla', ...props }) {
  return <GradientTooltip {...props} ownerState={{ variant, color }} arrow />;
}
